export const listaPedidosStore = {
    namespaced: true,
    state : {
        ListaPedidos: {},
    },
    mutations : {
        updateStateListaPedidos(state, payload) {
            state.ListaPedidos = payload;
        },
    },
    actions : {
        updateStateListaPedidos({ state, commit }, data) {
            commit('updateStateListaPedidos', data);
        },
    },
    getters : {
        ListaPedidos: (state, getters) => {
            return state.ListaPedidos;
        },   
    }
}